import { useEffect, useState } from 'react'
import styledCSSThemes from '~/themes'

import { useCurrentUserSetting } from './useCurrentUserSetting'

window.globalTheme = 'light'
const DARK_THEME = 'dark'
const LIGHT_THEME = 'light'
const themes = [DARK_THEME, LIGHT_THEME]

export function useLegacyTheme() {
  const [userTheme] = useCurrentUserSetting('session', 'theme', 'auto')
  const [currentTheme, setTheme] = useState<keyof typeof styledCSSThemes>(() => {
    // if auto
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return DARK_THEME
    } else {
      return LIGHT_THEME
    }
  })

  useEffect(() => {
    const themeColor = styledCSSThemes[currentTheme].colors.background
    window.globalTheme = currentTheme
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', themeColor)
  }, [currentTheme])

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove(...themes)

    const osColorSchemeChange = (event: MediaQueryListEvent) => {
      if (userTheme === 'auto') return
      root.classList.remove(...themes)
      if (event.matches) {
        root.classList.add(DARK_THEME)
        setTheme(DARK_THEME)
      } else {
        root.classList.add(LIGHT_THEME)
        setTheme(LIGHT_THEME)
      }
    }
    if (Object.keys(styledCSSThemes).includes(userTheme)) {
      root.classList.add(userTheme)
      setTheme(userTheme as keyof typeof styledCSSThemes)
    } else {
      if (
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches
      ) {
        root.classList.add(DARK_THEME)
        setTheme(DARK_THEME)
      } else {
        root.classList.add(LIGHT_THEME)
        setTheme(LIGHT_THEME)
      }

      window
        .matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('change', osColorSchemeChange)
    }

    return () => {
      window
        .matchMedia('(prefers-color-scheme: dark)')
        .removeEventListener('change', osColorSchemeChange)
    }
  }, [userTheme])

  return styledCSSThemes[currentTheme]
}
